"use client";

/** A page drawn from what this browser kept, whose open has not answered
 *  (offline, the server down): it says so, on every page, and that changes
 *  are paused until the server answers (client caching stage 2; VC-core,
 *  2026-10-19). Gone as soon as the open answers. */

import React, { useSyncExternalStore } from "react";
import { OFFLINE_REASON, onUnconfirmedChange, unconfirmedState } from "../../data/island-store/unconfirmed";

const none = { drawn: 0, offline: 0 };

export function UnconfirmedNotice() {
  const state = useSyncExternalStore(onUnconfirmedChange, unconfirmedState, () => none);
  if (state.offline === 0) return null;
  return (
    <div role="status" data-testid="island-unconfirmed"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-amber-300 bg-amber-50 px-4 py-2 text-center text-sm text-amber-900">
      <span className="font-medium">Not yet confirmed: offline.</span>{" "}
      {OFFLINE_REASON}
    </div>
  );
}
